import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';
import {SitesService} from '@shared/services/sites.service';
import {ErrorHandlingService} from '@shared/services/error-handling.service';
import {ToastService} from '@shared/services/toast.service';

@Component({
    selector: 'app-merge-modal',
    templateUrl: './merge-modal.component.html',
    styleUrls: ['./merge-modal.component.scss'],
    standalone: false
})
export class MergeModalComponent {
  selectedSites: any;
  correctSite: any;

  constructor(public sitesService: SitesService, public errorHandlingService: ErrorHandlingService,
              public activeModal: NgbActiveModal, public http: HttpClient, public toast: ToastService,
              public router: Router) {
  }


  cancel() {
    this.activeModal.dismiss();
  };

  submit() {
    this.errorHandlingService.customErrorMessage = true;
    var mergeSites = [];

    this.selectedSites.forEach((site) => {
      if (site !== this.correctSite) {
        mergeSites.push(site.globalid);
      }
    });

    var mergeSitesString = mergeSites.join(',');

    console.log(mergeSitesString);
    this.http.get(`${environment.baseUrl}/sites/merge_sites`, {
      params: {
        target_site: this.correctSite.globalid,
        merged_sites: mergeSitesString
      }
    }).subscribe(() => {
        this.toast.success("Merge successful.");
        this.router.navigate(['/site', this.correctSite.globalid])
      },
      (error) => {
        if (error.data.detail) this.toast.error(error.data.detail);
        else this.toast.error("Merge failed.")
      }, () => {
        this.activeModal.close();
        this.errorHandlingService.customErrorMessage = false;
      });
  };

}
